// extracted by mini-css-extract-plugin
export default {"span-one-col-in-grid":"TextField_span-one-col-in-grid__yRFfy","monoBlack":"TextField_monoBlack__F1DjU","monoGrey3":"TextField_monoGrey3__-GI+-"};